export * from './confirmation.component';
import './confirmation.config';
